import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"
import onebaseLogo from "../../../static/images/onebase-logo.png"

export default function AuthBrandHeader() {
  return (
    <Column
      sx={{
        mb: { xs: 3, sm: 4 },
        alignItems: "center",
        gap: 1,
        textAlign: "center",
      }}
    >
      <Row sx={{ alignItems: "center", justifyContent: "center", gap: 1.5 }}>
        <Box
          component="img"
          src={onebaseLogo}
          alt="OneBase logo"
          sx={{ height: { xs: 40, sm: 44 } }}
        />
        <Typography
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontSize: { xs: 28, sm: 32 },
            fontWeight: 700,
            lineHeight: 1,
          }}
        >
          <Box component="span" sx={{ color: "#FE35CF" }}>
            One
          </Box>
          <Box component="span" sx={{ color: "#8A35D0" }}>
            Base
          </Box>
        </Typography>
      </Row>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          fontWeight: 500,
          letterSpacing: "0.02em",
        }}
      >
        SmartSetter Recruiting Portal
      </Typography>
    </Column>
  )
}
